import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Button from 'components/Common/Button';
import styled from '@emotion/styled';
import { Basket } from 'types/common';
import { Stack } from '@mui/material';
import { dateFormat, formatAmount } from 'utils/helpers';

interface MediaCardProp {
    event?: Basket;
    title?: string;
    description?: string;
    source?: string;
    onClickNavigation: (id: number | undefined) => void;
}

const CardContainer = styled(Card)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: '#F2F2F6',
    padding: 12,
    margin: 12,
    marginTop: 23,
});

export default function MediaCard({ title, description, source, event, onClickNavigation }: MediaCardProp) {
    return (
        <CardContainer>
            {/* Card main content */}
            <Stack direction={{ xs: 'column', lg: 'row' }} alignItems={'center'}>
                {/* Card image */}
                <CardMedia
                    sx={{ width: 80, height: 80, marginRight: { xs: 0, lg: 4 } }}
                    image={event?.imgUrl || source}
                    title={title || ''}
                />

                {/* Card text content */}
                <CardContent style={{ flex: 1 }}>
                    <Typography gutterBottom variant="h5" component="div">
                        {event?.name || title || 'No Title'}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {description || event?.description}
                    </Typography>
                    <Stack direction="row" justifyContent="center" gap={4}>
                        <Typography variant="body2" style={{ color: '#1F2937', marginTop: 12 }}>
                            Basket Balance: {formatAmount(event?.balance || 0)}
                        </Typography>
                    </Stack>
                </CardContent>

                {/* Card side content */}
                {
                    <Typography sx={{ alignSelf: 'flex-start', color: '#1F2937', fontWeight: 400 }} variant="body2">
                        Started {event?.startDate ? dateFormat(event.startDate) : '-- -- --'}
                    </Typography>
                }
            </Stack>

            {/* Card action button */}
            <CardActions style={{ justifyContent: 'center' }}>
                <Button
                    sx={{ width: { xs: '80%', sm: '30%', lg: '20%', xl: '15%' }, fontSize: { xs: 14, md: 16 } }}
                    onClick={() => onClickNavigation(event?.id)}
                    title="View Details"
                />
            </CardActions>
        </CardContainer>
    );
}
